import Single from './Single'
import Color from './Color'
import MultipleBubble from './MultipleBubble'
import Scale from './Scale'

export default {
  Single,
  Color,
  MultipleBubble,
  Scale
}
